module.exports = __webpack_public_path__ + "img/company_wx.58a1f934.jpg";